(function (root) {
  const integer = value => Number.isSafeInteger(value) && value >= 0;
  const id = value => /^\d+$/.test(String(value));
  const freeze = value => { Object.values(value).forEach(item => { if (item && typeof item === 'object') freeze(item); }); return Object.freeze(value); };
  function create(input) {
    const config = JSON.parse(JSON.stringify(input));
    if (!config.id || !config.revision || config.currency !== 'PHP' ||
        !Number.isFinite(config.startsAt) || !Number.isFinite(config.endsAt) || config.endsAt <= config.startsAt ||
        !Array.isArray(config.eligibleVariantIds) || !config.eligibleVariantIds.length ||
        config.eligibleVariantIds.some(value => !id(value)) || !id(config.sampleVariantId) || config.sampleUnitCharge !== 10 ||
        config.eligibleVariantIds.map(String).includes(String(config.sampleVariantId))) throw new Error('INVALID_CAMPAIGN');
    const eligible = new Set(config.eligibleVariantIds.map(String));
    const floors = config.floorBps || {};
    if (Object.entries(floors).some(([key, value]) => !eligible.has(key) || !integer(value) || value > 10000)) throw new Error('INVALID_FLOOR');
    const tiers = [{ min: 2, bps: 1200, samples: 2 }, { min: 3, bps: 1800, samples: 3 }, { min: 5, bps: 2200, samples: 4 }];
    const active = now => Number.isFinite(now) && now >= config.startsAt && now < config.endsAt;
    const qualifies = line => eligible.has(String(line.variant_id ?? line.id)) && !line.selling_plan_allocation && !line.selling_plan;
    const evaluate = (cart, now = Date.now()) => {
      if (cart.currency !== config.currency || !Array.isArray(cart.items)) throw new Error('INVALID_CART_CURRENCY');
      if (cart.items.some(line => !id(line.variant_id ?? line.id) || !integer(line.quantity) || !integer(line.original_price ?? line.price))) throw new Error('INVALID_CART_LINE');
      const count = cart.items.filter(qualifies).reduce((sum, line) => sum + line.quantity, 0);
      const tier = active(now) ? tiers.filter(item => count >= item.min).at(-1) : null;
      const lines = cart.items.map(line => {
        const variantId = String(line.variant_id ?? line.id);
        const original = (line.original_price ?? line.price) * line.quantity;
        const bps = qualifies(line) ? Math.max(floors[variantId] || 0, tier?.bps || 0) : 0;
        return { id: variantId, quantity: line.quantity, original, bps, discount: Math.round(original * bps / 10000) };
      });
      const subtotal = lines.reduce((sum, line) => sum + line.original, 0);
      const discount = lines.reduce((sum, line) => sum + line.discount, 0);
      if (![count, subtotal, discount].every(integer)) throw new Error('AMOUNT_OVERFLOW');
      return { status: 'estimated', purchasable: false, campaignId: config.id, revision: config.revision,
        active: active(now), eligibleCount: count, sampleCap: tier?.samples || 0,
        sampleUnitCharge: config.sampleUnitCharge, subtotal, discount, total: subtotal - discount,
        lines, tiers: tiers.map(({ min, bps }) => ({ min, bps })) };
    };
    return Object.freeze({ evaluate, active, qualifies, milestones: () => tiers.map(({ min, bps, samples }) => ({ min, bps, samples })), config: freeze(config) });
  }
  const api = { version: 1, create };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.TheManBundleCampaign = api;
})(typeof window === 'object' ? window : globalThis);
